import React, { useEffect } from 'react';
import * as ReactPixel from 'meta-pixel';
import { Landing } from './pages/Landing';
const PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    try {
      const pixel: any = (ReactPixel as any).default ?? ReactPixel;
      if (typeof pixel.init === 'function') {
        pixel.init(PIXEL_ID);
        pixel.pageView?.();
      }
    } catch (e) {
      // fail silently — analytics shouldn't break the page
      console.warn('Meta Pixel failed to initialize', e);
    }
  }, []);
  return <Landing data-id="element-0" />;
}